import { notify } from 'utils/reduxUtils';

export const types = {
  FIELD_SETTINGS_FETCH_REQUEST:
    'settings/smart_rfq/FIELD_SETTINGS_FETCH_REQUEST',
  FIELD_SETTINGS_FETCH_SUCCESS:
    'settings/smart_rfq/FIELD_SETTINGS_FETCH_SUCCESS',
  FIELD_SETTINGS_FETCH_ERROR: 'settings/smart_rfq/FIELD_SETTINGS_FETCH_ERROR',
  FIELD_SETTINGS_UPDATE_ERROR: 'settings/smart_rfq/FIELD_SETTINGS_UPDATE_ERROR',
  FIELD_SETTINGS_UPDATE_REQUEST:
    'settings/smart_rfq/FIELD_SETTINGS_UPDATE_REQUEST',
  FIELD_SETTINGS_UPDATE_SUCCESS:
    'settings/smart_rfq/FIELD_SETTINGS_UPDATE_SUCCESS',
};

export const fieldSettingsFetch = {
  request: () => ({
    type: types.FIELD_SETTINGS_FETCH_REQUEST,
  }),
  success: ({
    defaultProcessId,
    processes,
    showProcessSelector,
    showMaterialSelector,
    showFinishSelector,
    showDeliveryDateSelector,
    showNotesField,
    showReferralField,
    showRfqNumberField,
    showContactAddressFields,
  }) => ({
    type: types.FIELD_SETTINGS_FETCH_SUCCESS,
    payload: {
      defaultProcessId,
      processes,
      showProcessSelector,
      showMaterialSelector,
      showFinishSelector,
      showDeliveryDateSelector,
      showNotesField,
      showReferralField,
      showRfqNumberField,
      showContactAddressFields,
    },
  }),
  error: notify(
    (error) => ({
      type: types.FIELD_SETTINGS_FETCH_ERROR,
      payload: error,
    }),
    "Can't fetch rfq settings.",
  ),
};

export const fieldSettingsUpdate = {
  request: ({
    defaultProcessId,
    showProcessSelector,
    showMaterialSelector,
    showFinishSelector,
    showDeliveryDateSelector,
    showNotesField,
    showReferralField,
    showRfqNumberField,
    showContactAddressFields,
  }) => ({
    type: types.FIELD_SETTINGS_UPDATE_REQUEST,
    payload: {
      defaultProcessId,
      showProcessSelector,
      showMaterialSelector,
      showFinishSelector,
      showDeliveryDateSelector,
      showNotesField,
      showReferralField,
      showRfqNumberField,
      showContactAddressFields,
    },
  }),
  success: notify(
    ({
      defaultProcessId,
      showProcessSelector,
      showMaterialSelector,
      showFinishSelector,
      showDeliveryDateSelector,
      showNotesField,
      showReferralField,
      showRfqNumberField,
      showContactAddressFields,
    }) => ({
      type: types.FIELD_SETTINGS_UPDATE_SUCCESS,
      payload: {
        defaultProcessId,
        showProcessSelector,
        showMaterialSelector,
        showFinishSelector,
        showDeliveryDateSelector,
        showNotesField,
        showReferralField,
        showRfqNumberField,
        showContactAddressFields,
      },
    }),
    'SmartRFQ field settings updated',
  ),
  error: notify(
    (error) => ({
      type: types.FIELD_SETTINGS_UPDATE_ERROR,
      payload: error,
    }),
    "Can't update rfq settings.",
  ),
};
